"use client";

import React from "react";
import Image from "next/image";

const ChooseSmile4Me: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Choose Smile4Me Dental Care for Professional Teeth Whitening Astoria
          Offers
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/photo-man-in-suit-standing-in-dental-office-with-smile4me-sign-behind-him-teeth-whitening-astoria-clinic-interior-marble-wall-background.jpg"
            alt="Dr. Khaimov standing in the Smile4Me Dental Care office in Astoria"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, we combine advanced technology with a
          personalized approach to deliver safe, effective, and noticeable teeth
          whitening results. Whether you&apos;re looking for fast in-office
          treatment or a custom take-home solution, our team focuses on helping
          you achieve a brighter smile that looks natural and lasts. Every
          treatment is carefully planned to match your goals, ensuring you get
          the best possible outcome with minimal sensitivity.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          We don&apos;t just whiten teeth; we prioritize your overall oral health
          while enhancing your smile. From your initial consultation to your
          final results, our goal is to provide a smooth, comfortable experience
          that leaves you confident in your smile.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          Why Patients Trust Smile4Me Dental Care
        </h3>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            Experienced dental professionals with a strong track record in
            cosmetic dentistry
          </li>
          <li>
            State-of-the-art whitening systems for faster, more effective
            results
          </li>
          <li>
            Personalized treatment plans tailored to your smile goals
          </li>
          <li>
            Strict safety protocols to protect enamel and reduce sensitivity
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          We focus on delivering results that not only look great but also
          support your long-term oral health.
        </p>
      </div>
    </section>
  );
};

export default ChooseSmile4Me;
